import { render, staticRenderFns } from "./TextBoxDesigner.vue?vue&type=template&id=86df1540&scoped=true&"
import script from "./TextBoxDesigner.vue?vue&type=script&lang=js&"
export * from "./TextBoxDesigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86df1540",
  null
  
)

export default component.exports